module.exports = __webpack_public_path__ + "static/media/nosotros01.9ca99f89.jpg";